import { useTranslation } from "react-i18next";

import Typo from "~/components/atoms/Typo";
import { cn } from "~/utilities/cn";
import { ETypoColor } from "~/utilities/enums/Colors";
import { ETypoTag, ETypoVariant } from "~/utilities/enums/Typo";

export enum EResultHeaderVariant {
  DEFAULT = "default",
  VIRTUAL = "virtual",
}

type TResultHeaderProps = {
  variant?: EResultHeaderVariant;
  totalResult: number | string;
  totalGroups?: number;
  title?: string;
  containerClassName?: string;
};

const ResultHeader: React.FC<TResultHeaderProps> = ({
  totalResult,
  totalGroups,
  variant = EResultHeaderVariant.DEFAULT,
  title = "Result",
  containerClassName,
}) => {
  const { t } = useTranslation();
  if (variant === "virtual") {
    return (
      <div className={cn("flex items-center gap-x-3", containerClassName)}>
        <Typo
          tag={ETypoTag.H3}
          variant={ETypoVariant.HEADER_32}
          color={ETypoColor.TEXT}
          className="font-bold lg:text-header-20"
        >
          {title}
        </Typo>
        <div className="flex items-center gap-2 justify-center">
          <div className="rounded-[21.5px] bg-color px-6 py-1 lg:rounded-xl">
            <Typo
              tag={ETypoTag.P}
              variant={ETypoVariant.SUB_TITLE_16}
              color={ETypoColor.WHITE}
              className="font-bold text-backgroundPageProject lg:!text-body-title-12"
            >
              {totalGroups}
            </Typo>
          </div>
          <Typo
              tag={ETypoTag.P}
              variant={ETypoVariant.SUB_TITLE_16}
              color={ETypoColor.TEXT}
              className="font-bold first-letter:uppercase text-color lg:!text-body-title-12"
            >
              {Number(totalGroups) > 1 ? "Projects" : "Project" }
            </Typo>
        </div>
      </div>
    );
  }
  return (
    <div
      className={cn(
        "flex items-center justify-center gap-x-3",
        containerClassName
      )}
    >
      <Typo
        tag={ETypoTag.H3}
        variant={ETypoVariant.BODY_TITLE_16}
        color={ETypoColor.TEXT}
      >
        {`${totalResult} ${t(" properties")}`}
      </Typo>
    </div>
  );
};

export default ResultHeader;
